/* Download decorative card hover media only when a desktop visitor approaches a card. */
(() => {
  const key = Symbol.for('yilianduo.cardSecondary20260930');
  if (document[key]) return;
  document[key] = true;
  const pending = new WeakSet();
  const load = (event) => {
    if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
    if (event.pointerType === 'touch' || !(event.target instanceof Element)) return;
    const card = event.target.closest('.card-wrapper');
    const template = card?.querySelector('.card__media > template.yld-card-secondary');
    if (!template || pending.has(template)) return;
    const media = template.previousElementSibling;
    if (!media?.classList.contains('media')) return;
    const source = template.content.querySelector('img');
    if (!source) return;
    const img = document.importNode(source, true);
    pending.add(template);
    img.loading = 'eager';
    const ready = () => {
      if (!template.isConnected || !img.naturalWidth) return;
      media.appendChild(img);
      template.remove();
    };
    img.addEventListener('load', ready, { once: true });
    img.addEventListener('error', () => pending.delete(template), { once: true });
    // Reassigning src starts detached image loading without hiding the primary image.
    img.src = img.getAttribute('src');
    if (img.complete && img.naturalWidth) ready();
  };
  document.addEventListener('pointerover', load, { passive: true });
  document.addEventListener('focusin', load);
})();
